import { render, staticRenderFns } from "./webCamera.vue?vue&type=template&id=1047dc56"
import script from "./webCamera.vue?vue&type=script&lang=js"
export * from "./webCamera.vue?vue&type=script&lang=js"
import style0 from "./webCamera.vue?vue&type=style&index=0&id=1047dc56&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports